import RefreshIcon from '@mui/icons-material/Refresh';
import { SegnalazioniService } from '../../../services/controllers/segnalazioni-services/SegnalazioniService';
import StorBeFeParser from '../../utils/storBeFeParser';
import SegnalazioneType from '../../variables/SegnalazioniType';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from "@mui/material";
import { useState } from 'react';
import CONSTANTS from '../../utils/Constants';
import { SegnalazioneInput } from '../../../services/models/input-objs/SegnalazioneInput';
import SegnalazioneTypeLabels from '../../variables/SegnalazioneTypeLabels';
import { SendingStorOutput } from '../../../services/models/output-objs/sendingStoreOutput';


const customStyle = {
    color: "#004D99",
    width: 30,
    height: 30,
};



const CustomRefreshIconButton = (props : any) => {
    
    const [open, setOpen] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(checkUser());
    const [justification, setJust] = useState<String>();
    const segnalazioniService : SegnalazioniService = new SegnalazioniService()

    const handleCancel = () => {
        let resetJust = ''
        setJust(resetJust)
        setOpen(false)
    }

    function checkUser(){
      if(props.user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole)){
        return false
      }
      else
        return true
    }

    function setJustification(event : any){
        if(event && event.target && event.target.value!==''){
          setButtonDisabled(false)
        }
        else
          setButtonDisabled(true)
        setJust(event.target.value)
    }
    
    async function cloneSegnalazione(idSegnalazione : string) {
        sessionStorage.setItem('idSegnalazione', idSegnalazione)
        getStorByIDEffect()
    }

    async function getStorByIDEffect(){
        const response = await segnalazioniService.cloneStor(sessionStorage?.getItem('idSegnalazione') || '');
        if (response){
            response.updateReason = justification;
            const parsedSegnalazione = await StorBeFeParser.parseBetoFe(response)
            sessionStorage.setItem('idSegnalazioneCreazione', parsedSegnalazione?.systemInformations?.id || '')
            if(parsedSegnalazione && parsedSegnalazione?.systemInformations?.type){
                switch(parsedSegnalazione?.systemInformations?.type){
                    case 'STOR':
                        sessionStorage.setItem('segnalazioneType', SegnalazioneType.STOR)
                        break;
                    case 'Market Observation':
                        sessionStorage.setItem('segnalazioneType', SegnalazioneType.MARKET_OBSERVATION)
                        break;
                    default :
                        sessionStorage.setItem('segnalazioneType', SegnalazioneType.ALTRO)
                }
            }
            sessionStorage.setItem('newSegnalazione', JSON.stringify(parsedSegnalazione))
            saveStor(parsedSegnalazione)
        }
    }

    async function saveStor(newSegnalazione : SegnalazioneInput){
        const segnalazioniService : SegnalazioniService = new SegnalazioniService();
        const segnalazioneT = (newSegnalazione['systemInformations'] && newSegnalazione['systemInformations']['type']) ? SegnalazioneTypeLabels[newSegnalazione['systemInformations']['type']] : ""
        const sendingStor : SendingStorOutput = StorBeFeParser.parseFetoBe(newSegnalazione,segnalazioneT,'0',sessionStorage?.getItem('idSegnalazioneCreazione') || null)
        await segnalazioniService.saveStor(sendingStor)
        window.location.href = '/stor-fe/stor/create'
    }
    

    return <div className="d-inline w-25"> 
        <IconButton aria-label="refresh" style={customStyle} title={props.title} onClick={() => setOpen(true)}>
            <RefreshIcon />
        </IconButton>
        <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        >
        <DialogTitle id="alert-dialog-title">
          Giustificazione
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Inserisci una giustificazione per la ricarica
          </DialogContentText>
          <TextField
            autoFocus
            rows={5}
            multiline
            margin = "dense"
            id = "justification"
            label = "Giustificazione"
            type = "text"
            onChange={(event => {setJustification(event)})}
            defaultValue={justification}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Annulla</Button>
          <Button onClick={() => cloneSegnalazione(props.idSegnalazione)} autoFocus disabled = {buttonDisabled}>
            Continua
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    
}

export default CustomRefreshIconButton;